// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { WebService } from "../../Services/WebService";
// import { PageInfo } from "../PageInfo";
// import StaticListComponent from "../../Services/StaticListComponent";
// import { StandardConst } from "../../Services/StandardConst";
// import { NoRecordTemplate } from "../../Services/TableComponent";
// import { Chip, Tooltip } from "@mui/material";
// import { Button, Card, Tabs, Tab, ProgressBar } from "react-bootstrap";
// import { TaskAlt, PendingActions, Cancel } from "@mui/icons-material";

// const BroadcastDocumentStatus = () => {
//   const { state } = useLocation();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [statusData, setStatusData] = useState([]);
//   const [documentInfo, setDocumentInfo] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [activeTab, setActiveTab] = useState("all");

//   PageInfo({ pageTitle: "Document Recipients Status" });

//   const [bData] = React.useState([
//     {
//       title: "Broadcast Document List",
//       hrefLink: "/ManageBroadcastDocument",
//     },
//     {
//       title: "Recipients Status",
//       hrefLink: "",
//     },
//   ]);

//   useEffect(() => {
//     if (state?.BroadcastDocumentId) {
//       fetchStatus();
//     } else {
//       navigate("/ManageBroadcastDocument");
//     }
//   }, [state]);

//   const fetchStatus = async () => {
//     setIsLoading(true);
//     try {
//       const result = await WebService({
//         endPoint: `Document/GetBroadcastDocumentStatus/${state.BroadcastDocumentId}`,
//         method: "GET",
//         dispatch,
//       });

//       if (result?.result) {
//         setStatusData(result.result.recipients || []);
//         setDocumentInfo(result.result.documentInfo);
//       }
//     } catch (error) {
//       console.error("Error fetching status:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   function beautifyLocalTime(utcTimestamp) {
//     if (!utcTimestamp) return '-';
//     const utcDate = new Date(utcTimestamp);
//     const options = {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: 'numeric',
//       minute: 'numeric',
//       second: 'numeric',
//       hour12: true,
//     };
//     return new Intl.DateTimeFormat(undefined, options).format(utcDate);
//   }

//   const getStatusChip = (status) => {
//     const statusConfig = {
//       'Sent': { color: 'info', label: 'Sent', icon: <PendingActions fontSize="small" /> },
//       'Acknowledged': { color: 'success', label: 'Acknowledged', icon: <TaskAlt fontSize="small" /> },
//       'Signed': { color: 'success', label: 'Signed', icon: <TaskAlt fontSize="small" /> },
//       'Pending': { color: 'warning', label: 'Pending', icon: <PendingActions fontSize="small" /> },
//       'Failed': { color: 'error', label: 'Failed', icon: <Cancel fontSize="small" /> },
//     };

//     const config = statusConfig[status] || statusConfig['Pending'];
    
//     return (
//       <Chip
//         label={config.label}
//         size="small"
//         color={config.color}
//         icon={config.icon}
//       />
//     );
//   };

//   const calculateStats = () => {
//     if (!statusData || statusData.length === 0) {
//       return {
//         total: 0,
//         sent: 0,
//         acknowledged: 0,
//         signed: 0,
//         pending: 0,
//         failed: 0
//       };
//     }

//     return {
//       total: statusData.length,
//       sent: statusData.filter(d => d.Status === 'Sent').length,
//       acknowledged: statusData.filter(d => d.Status === 'Acknowledged').length,
//       signed: statusData.filter(d => d.Status === 'Signed').length,
//       pending: statusData.filter(d => d.Status === 'Pending').length,
//       failed: statusData.filter(d => d.Status === 'Failed').length,
//     };
//   };

//   const stats = calculateStats();
//   const completionRate = stats.total > 0 
//     ? Math.round(((stats.acknowledged + stats.signed) / stats.total) * 100) 
//     : 0;

//   // Filter data based on active tab
//   const filteredData = statusData.filter(item => {
//     if (activeTab === "all") return true;
//     if (activeTab === "signed") return item.Status === "Signed";
//     if (activeTab === "acknowledged") return item.Status === "Acknowledged";
//     if (activeTab === "pending") return item.Status === "Pending" || item.Status === "Sent";
//     if (activeTab === "failed") return item.Status === "Failed";
//     return true;
//   });

//   const columns = [
//     {
//       Text: "Employee Details",
//       Value: "EmployeeName",
//       exportValue: (dr) => {
//         return ` ${dr.EmployeeName ? dr.EmployeeName : dr.EmployeeEmail}`;
//       },
//       render: (dr) => (
//         <div>
//           <strong>{dr.EmployeeName}</strong>
//           <br />
//           <small className="text-muted">{dr.EmployeeEmail}</small>
//         </div>
//       )
//     },
//     {
//       Text: "Sent Date & Time",
//       Value: "SentAt",
//       exportValue: (dr) => {
//         return ` ${dr.SentAt}`;
//       },
//       render: (dr) => (
//         <>{dr.SentAt ? beautifyLocalTime(dr.SentAt) : <span className="text-muted">Not Sent</span>}</>
//       )
//     },
//     {
//       Text: "Status",
//       Value: "Status",
//       cssClass: "text-center",
//       exportValue: (dr) => {
//         return ` ${dr.Status}`;
//       },
//       render: (dr) => getStatusChip(dr.Status)
//     },
//     {
//       Text: "Sign Date",
//       Value: "ActionDate",
//       exportValue: (dr) => {
//         return ` ${dr.SignedAt}`;
//       },
//       render: (dr) => {
//         if (dr.SignedAt) {
//           return (
//             <div>
//               <span className="text-success">✍️ Signed</span>
//               <br />
//               <small>{beautifyLocalTime(dr.SignedAt)}</small>
//             </div>
//           );
//         } else if (dr.AcknowledgedAt) {
//           return (
//             <div>
//               <span className="text-info">✓ Acknowledged</span>
//               <br />
//               <small>{beautifyLocalTime(dr.AcknowledgedAt)}</small>
//             </div>
//           );
//         } else {
//           return <span className="text-muted">-</span>;
//         }
//       }
//     },
//     // {
//     //   Text: "Location",
//     //   Value: "Location",
//     //   render: (dr) => {
//     //     if (dr.Location) {
//     //       try {
//     //         const loc = JSON.parse(dr.Location);
//     //         return (
//     //           <Tooltip title={`Lat: ${loc.latitude}, Long: ${loc.longitude}`}>
//     //             <small className="text-muted">
//     //               📍 {loc.latitude?.toFixed(4)}, {loc.longitude?.toFixed(4)}
//     //             </small>
//     //           </Tooltip>
//     //         );
//     //       } catch {
//     //         return <span className="text-muted">-</span>;
//     //       }
//     //     }
//     //     return <span className="text-muted">-</span>;
//     //   }
//     // },
//     // {
//     //   Text: "Remarks",
//     //   Value: "Remarks",
//     //   render: (dr) => (
//     //     <>
//     //       {dr.Remarks ? (
//     //         <Tooltip title={dr.Remarks}>
//     //           <span className="text-truncate d-inline-block" style={{ maxWidth: '150px' }}>
//     //             {dr.Remarks}
//     //           </span>
//     //         </Tooltip>
//     //       ) : (
//     //         <span className="text-muted">-</span>
//     //       )}
//     //     </>
//     //   )
//     // },
//   ];

//   return (
//     <>
//       {/* Document Info Card */}
//       {documentInfo && (
//         <Card className="mb-3 shadow-sm">
//           <Card.Body>
//             <div className="d-flex justify-content-between align-items-center mb-3">
//               <div>
//                 <h5 className="mb-1">
//                   {documentInfo.Title || state.Title}
//                   <Chip label="Auto-Broadcast" size="small" color="warning" className="ms-2" />
//                 </h5>
//                 {documentInfo.Label && (
//                   <p className="text-muted mb-0">
//                     <small>{documentInfo.Label}</small>
//                   </p>
//                 )}
//               </div>
//               <Button
//                 variant="outline-primary"
//                 size="sm"
//                 onClick={() => navigate("/ManageBroadcastDocument")}
//               >
//                 ← Back to List
//               </Button>
//             </div>

//             {/* Progress Bar */}
//             <div className="mb-3">
//               <div className="d-flex justify-content-between mb-1">
//                 <small className="text-muted">Completion Progress</small>
//                 <small className="text-muted">{completionRate}%</small>
//               </div>
//               <ProgressBar>
//                 <ProgressBar 
//                   variant="success" 
//                   now={(stats.signed / stats.total) * 100} 
//                   key={1}
//                   label={stats.signed > 0 ? `${stats.signed} Signed` : ''}
//                 />
//                 <ProgressBar 
//                   variant="info" 
//                   now={(stats.acknowledged / stats.total) * 100} 
//                   key={2}
//                   label={stats.acknowledged > 0 ? `${stats.acknowledged} Ack` : ''}
//                 />
//               </ProgressBar>
//             </div>

//             {/* Statistics Cards */}
//             <div className="row text-center">
//               <div className="col-md-2">
//                 <div className="p-2 bg-light rounded">
//                   <h4 className="mb-0">{stats.total}</h4>
//                   <small className="text-muted">Total</small>
//                 </div>
//               </div>
//               <div className="col-md-2">
//                 <div className="p-2 bg-success bg-opacity-10 rounded">
//                   <h4 className="mb-0 text-success">{stats.signed}</h4>
//                   <small className="text-muted">Signed</small>
//                 </div>
//               </div>
//               {/* <div className="col-md-2">
//                 <div className="p-2 bg-info bg-opacity-10 rounded">
//                   <h4 className="mb-0 text-info">{stats.acknowledged}</h4>
//                   <small className="text-muted">Acknowledged</small>
//                 </div>
//               </div> */}
//               {/* <div className="col-md-2">
//                 <div className="p-2 bg-warning bg-opacity-10 rounded">
//                   <h4 className="mb-0 text-warning">{stats.pending}</h4>
//                   <small className="text-muted">Pending</small>
//                 </div>
//               </div> */}
//               <div className="col-md-2">
//                 <div className="p-2 bg-primary bg-opacity-10 rounded">
//                   <h4 className="mb-0 text-primary">{stats.sent}</h4>
//                   <small className="text-muted">Sent</small>
//                 </div>
//               </div>
//               {/* <div className="col-md-2">
//                 <div className="p-2 bg-danger bg-opacity-10 rounded">
//                   <h4 className="mb-0 text-danger">{stats.failed}</h4>
//                   <small className="text-muted">Failed</small>
//                 </div>
//               </div> */}
//             </div>
//           </Card.Body>
//         </Card>
//       )}

//       {/* Tabs and Table */}
//       <Card className="shadow-sm">
//         <Card.Header>
//           <Tabs
//             activeKey={activeTab}
//             onSelect={(k) => setActiveTab(k)}
//             className="mb-0"
//           >
//             <Tab eventKey="all" title={`All (${stats.total})`} />
//             <Tab eventKey="signed" title={`✍️ Signed (${stats.signed})`} />
//             {/* <Tab eventKey="acknowledged" title={`✓ Acknowledged (${stats.acknowledged})`} /> */}
//             {/* <Tab eventKey="pending" title={`⏳ Pending (${stats.pending})`} /> */}
//             {/* {stats.failed > 0 && <Tab eventKey="failed" title={`❌ Failed (${stats.failed})`} />} */}
//           </Tabs>
//         </Card.Header>
//         <Card.Body className="p-0">
//           <StaticListComponent
//             columns={columns}
//             data={filteredData}
//             bData={bData}
//             MasterPageName="Recipients Status"
//             noRecordCss="p-0"
//             noRecordFound={
//               <NoRecordTemplate
//                 headerValue="No Recipients Found"
//                 subHeaderValue="No employees match the selected filter"
//                 imageUrl={StandardConst.imageNoRecordsFound}
//               />
//             }
//             IsAddButtonVisible={false}
//             isSearchRequired={true}
//             allowSerialNo={true}
//           />
//         </Card.Body>
//       </Card>
//     </>
//   );
// };

// export default BroadcastDocumentStatus;




import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { WebService } from "../../Services/WebService";
import { PageInfo } from "../PageInfo";
import StaticListComponent from "../../Services/StaticListComponent";
import { StandardConst } from "../../Services/StandardConst";
import { NoRecordTemplate } from "../../Services/TableComponent";
import { Chip, Tooltip } from "@mui/material";
import { Button, Card, ProgressBar } from "react-bootstrap";
import { TaskAlt, PendingActions, Cancel } from "@mui/icons-material";

const BroadcastDocumentStatus = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [statusData, setStatusData] = useState([]);
  const [documentInfo, setDocumentInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  PageInfo({ pageTitle: "Document Recipients Status" });

  const [bData] = React.useState([
    {
      title: "Broadcast Document List",
      hrefLink: "/ManageBroadcastDocument",
    },
    {
      title: "Recipients Status",
      hrefLink: "",
    },
  ]);

  useEffect(() => {
    if (state?.BroadcastDocumentId) {
      fetchStatus();
    } else {
      navigate("/ManageBroadcastDocument");
    }
  }, [state]);
const approvedStatus = StandardConst.Status.Approved;

  const fetchStatus = async () => {
    setIsLoading(true);
    
    try {
      const result = await WebService({
        endPoint: `Document/GetBroadcastDocumentStatus/${state.BroadcastDocumentId}?status=${approvedStatus}`,
        method: "GET",
        dispatch,
      });

      if (result?.result) {
        console.log(result?.result);
        setStatusData(result.result.recipients || []);
        setDocumentInfo(result.result.documentInfo);
      }
    } catch (error) {
      console.error("Error fetching status:", error);
    } finally {
      setIsLoading(false);
    }
  };

  function beautifyLocalTime(utcTimestamp) {
    if (!utcTimestamp) return '-';
    const utcDate = new Date(utcTimestamp);
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true,
    };
    return new Intl.DateTimeFormat(undefined, options).format(utcDate);
  }

  const getStatusChip = (status) => {
    const statusConfig = {
      'Sent': { color: 'info', label: 'Pending', icon: '' },
      'Acknowledged': { color: 'success', label: 'Acknowledged', icon: <TaskAlt fontSize="small" /> },
      'Signed': { color: 'success', label: 'Signed', icon: <TaskAlt fontSize="small" /> },
      'Pending': { color: 'warning', label: 'Pending', icon: <PendingActions fontSize="small" /> },
      'Failed': { color: 'error', label: 'Failed', icon: <Cancel fontSize="small" /> },
    };

    const config = statusConfig[status] || statusConfig['Pending'];
    
    return (
      <Chip
        label={config.label}
        size="small"
        color={config.color}
        icon={config.icon}
      />
    );
  };

  const calculateStats = () => {
    if (!statusData || statusData.length === 0) {
      return {
        total: 0,
        sent: 0,
        acknowledged: 0,
        signed: 0,
        pending: 0,
        failed: 0
      };
    }

    return {
      total: statusData.length,
      sent: statusData.filter(d => d.Status === 'Sent').length,
      acknowledged: statusData.filter(d => d.Status === 'Acknowledged').length,
      signed: statusData.filter(d => d.Status === 'Signed').length,
      pending: statusData.filter(d => d.Status === 'Pending').length,
      failed: statusData.filter(d => d.Status === 'Failed').length,
    };
  };

  const stats = calculateStats();
  const completionRate = stats.total > 0 
    ? Math.round(((stats.acknowledged + stats.signed) / stats.total) * 100) 
    : 0;

  // No filtering - show all data
  const filteredData = statusData;

  const columns = [
    {
      Text: "Employee Details",
      Value: "EmployeeName",
      exportValue: (dr) => {
        return ` ${dr.EmployeeName ? dr.EmployeeName : dr.EmployeeEmail}`;
      },
      render: (dr) => (
        <div>
          <strong>{dr.EmployeeName}</strong>
          <br />
          <small className="text-muted">{dr.EmployeeEmail}</small>
        </div>
      )
    },
    {
      Text: "Sent Date & Time",
      Value: "SentAt",
      render: (dr) => (
        <>{dr.SentAt ? beautifyLocalTime(dr.SentAt) : <span className="text-muted">Not Sent</span>}</>
      )
    },
    {
      Text: "Status",
      Value: "Status",
      cssClass: "text-center",
      exportValue: (dr) => {
        // return getStatusChip(dr.Status);
        return dr.Status === 'Sent' ? 'pending' : (dr.Status || '');
      },
      // render: (dr) => getStatusChip(dr.Status)
      
    },
    {
      Text: "Sign Date",
      Value: "ActionDate",
       exportValue: (dr) => {
        return ` ${dr.SignedAt ? beautifyLocalTime(dr.SignedAt) : dr.AcknowledgedAt ? beautifyLocalTime(dr.AcknowledgedAt) : '' }`;
      },
      render: (dr) => {
        if (dr.SignedAt) {
          return (
            <div>
              <span className="text-success">✍️ Signed</span>
              <br />
              <small>{beautifyLocalTime(dr.SignedAt)}</small>
            </div>
          );
        } else if (dr.AcknowledgedAt) {
          return (
            <div>
              <span className="text-info">✓ Acknowledged</span>
              <br />
              <small>{beautifyLocalTime(dr.AcknowledgedAt)}</small>
            </div>
          );
        } else {
          return <span className="text-muted">-</span>;
        }
      }
    },
    // {
    //   Text: "Location",
    //   Value: "Location",
    //   render: (dr) => {
    //     if (dr.Location) {
    //       try {
    //         const loc = JSON.parse(dr.Location);
    //         return (
    //           <Tooltip title={`Lat: ${loc.latitude}, Long: ${loc.longitude}`}>
    //             <small className="text-muted">
    //               📍 {loc.latitude?.toFixed(4)}, {loc.longitude?.toFixed(4)}
    //             </small>
    //           </Tooltip>
    //         );
    //       } catch {
    //         return <span className="text-muted">-</span>;
    //       }
    //     }
    //     return <span className="text-muted">-</span>;
    //   }
    // },
    // {
    //   Text: "Remarks",
    //   Value: "Remarks",
    //   render: (dr) => (
    //     <>
    //       {dr.Remarks ? (
    //         <Tooltip title={dr.Remarks}>
    //           <span className="text-truncate d-inline-block" style={{ maxWidth: '150px' }}>
    //             {dr.Remarks}
    //           </span>
    //         </Tooltip>
    //       ) : (
    //         <span className="text-muted">-</span>
    //       )}
    //     </>
    //   )
    // },
  ];
const masterPageName =
  documentInfo?.Title ||
  state?.Title ||
  "Recipients Status";
  return (
    <>
      {/* Document Info Card */}
      {/* {documentInfo && (
        <Card className="mb-3 shadow-sm">
          <Card.Body>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5 className="mb-1">
                  {documentInfo.Title || state.Title}
                  <Chip label="Auto-Broadcast" size="small" color="warning" className="ms-2" />
                </h5>
                {documentInfo.Label && (
                  <p className="text-muted mb-0">
                    <small>{documentInfo.Label}</small>
                  </p>
                )}
              </div>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() => navigate("/ManageBroadcastDocument")}
              >
                ← Back to List
              </Button>
            </div> */}

            {/* Progress Bar */}
            {/* <div className="mb-3">
              <div className="d-flex justify-content-between mb-1">
                <small className="text-muted">Completion Progress</small>
                <small className="text-muted">{completionRate}%</small>
              </div>
              <ProgressBar>
                <ProgressBar 
                  variant="success" 
                  now={(stats.signed / stats.total) * 100} 
                  key={1}
                  label={stats.signed > 0 ? `${stats.signed} Signed` : ''}
                />
                <ProgressBar 
                  variant="info" 
                  now={(stats.acknowledged / stats.total) * 100} 
                  key={2}
                  label={stats.acknowledged > 0 ? `${stats.acknowledged} Ack` : ''}
                />
              </ProgressBar>
            </div> */}

            {/* Statistics Cards */}
            {/* <div className="row text-center">
              <div className="col-md-2">
                <div className="p-2 bg-light rounded">
                  <h4 className="mb-0">{stats.total}</h4>
                  <small className="text-muted">Total</small>
                </div>
              </div>
              <div className="col-md-2">
                <div className="p-2 bg-success bg-opacity-10 rounded">
                  <h4 className="mb-0 text-success">{stats.signed}</h4>
                  <small className="text-muted">Signed</small>
                </div>
              </div>
              <div className="col-md-2">
                <div className="p-2 bg-info bg-opacity-10 rounded">
                  <h4 className="mb-0 text-info">{stats.acknowledged}</h4>
                  <small className="text-muted">Acknowledged</small>
                </div>
              </div>
              <div className="col-md-2">
                <div className="p-2 bg-warning bg-opacity-10 rounded">
                  <h4 className="mb-0 text-warning">{stats.pending}</h4>
                  <small className="text-muted">Pending</small>
                </div>
              </div>
              <div className="col-md-2">
                <div className="p-2 bg-primary bg-opacity-10 rounded">
                  <h4 className="mb-0 text-primary">{stats.sent}</h4>
                  <small className="text-muted">Sent</small>
                </div>
              </div>
              <div className="col-md-2">
                <div className="p-2 bg-danger bg-opacity-10 rounded">
                  <h4 className="mb-0 text-danger">{stats.failed}</h4>
                  <small className="text-muted">Failed</small>
                </div>
              </div>
            </div>
          </Card.Body>
        </Card> */}
      {/* )} */}

      {/* Table without Tabs */}
      <Card className="shadow-sm">
        <Card.Body className="p-0">
          <StaticListComponent
            columns={columns}
            data={filteredData}
            bData={bData}
            // MasterPageName={documentInfo.Title || state.Title || "Recipients Status" }
             MasterPageName={masterPageName} 
            noRecordCss="p-0"
            noRecordFound={
              <NoRecordTemplate
                headerValue="No Recipients Found"
                subHeaderValue="No employees found for this document"
                imageUrl={StandardConst.imageNoRecordsFound}
              />
            }
            IsAddButtonVisible={false}
            isSearchRequired={true}
            allowSerialNo={true}
          />
        </Card.Body>
      </Card>
    </>
  );
};

export default BroadcastDocumentStatus;